export default __webpack_public_path__ + "static/media/pagbank.alt.b26dde07.png";